import {ClientEvent} from '@udemy/event-tracking';

import {BRAND_PATH_TYPES} from './constants';

export class CourseTakingBrandPathEnrolled extends ClientEvent {
    constructor({pathName, uiRegion}: {pathName: string; uiRegion: string}) {
        super('CourseTakingBrandPathEnrolled');
        this.brandPath = {pathName, brand: BRAND_PATH_TYPES.GOOGLE};
        this.uiRegion = uiRegion;
    }

    brandPath: {pathName: string; brand: string};
    uiRegion: string;
}
